module.exports = __webpack_public_path__ + "static/other/organize_desk_game_desk_3.e06292ad.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/organizeDeskGame/organize_desk_game_desk_3.json
// module id = 2351
// module chunks = 0